import React, { useContext } from "react";

import { CircularProgress, Grid, Paper, Typography } from "@material-ui/core";

import { Alert } from "@material-ui/lab";

import useWTMPageStyles from "./useWTMPageStyles";

import WebTrackerOverviewTable from "./WebTrackerOverviewTable";
import { EmptyState } from "./EmptyState";
import useFeatureFlags from "../../hooks/useFeatureFlag";
import ActiveDestinationsTable from "./ActiveDestinationsTable";
import { theme } from "../../theme";
import { OverviewDataContext } from "../OverviewDataContextProvider";

export function ListTab() {
  const classes = useWTMPageStyles();
  const flags = useFeatureFlags();

  const { latestReport, latestReportError, latestReportLoading } = useContext(
    OverviewDataContext
  );

  if (latestReportError) {
    return (
      <Alert severity="error">
        <Typography variant="body1">
          Something went wrong. Try refreshing the page, or contact
          support@freshpaint.io for assistance.
        </Typography>
      </Alert>
    );
  }

  if (latestReportLoading) {
    return (
      <div className={classes.loader}>
        <CircularProgress />
      </div>
    );
  }

  if (latestReport === undefined) {
    return <EmptyState />;
  }

  return (
    <Paper square style={{ padding: theme.spacing(2) }}>
      <Grid container spacing={2}>
        {flags("unifiedDestinationsUI") && (
          <Grid item xs={12}>
            <ActiveDestinationsTable />
          </Grid>
        )}

        <Grid item xs={12}>
          <WebTrackerOverviewTable />
        </Grid>
      </Grid>
    </Paper>
  );
}

export default ListTab;
